/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdinformatik12Inputs */

const en__field_enum_sdinformatik12 = /** @type {(inputs: _Field_Enum_Sdinformatik12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 - Informatik und Mathematik`)
};

const de__field_enum_sdinformatik12 = /** @type {(inputs: _Field_Enum_Sdinformatik12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 - Informatik und Mathematik`)
};

/**
* | output |
* | --- |
* | "12 - Informatik und Mathematik" |
*
* @param {_Field_Enum_Sdinformatik12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdinformatik12 = /** @type {((inputs?: _Field_Enum_Sdinformatik12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdinformatik12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdinformatik12(inputs)
	return de__field_enum_sdinformatik12(inputs)
});
export { _field_enum_sdinformatik12 as "_field_enum_SDINFORMATIK" }